import React from 'react';
import { getViolationType } from 'src/utils/stowage/violations/violationsUtils';
import { RedTriangle, WarningTriangle, YellowTriangle } from '../tankPlanView/TankPlanViewer.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';

type Props = {
    violationType: StowageRuleConsequenceType;
    includeText: boolean;
    count?: number | null;
    customTitle?: string;
};
const ViolationListIconComponent: React.FC<Props> = (props) => {
    return (
        <>
            {props.violationType && (
                <WarningTriangle>
                    {props.violationType === StowageRuleConsequenceType.HardRule && (
                        <RedTriangle className="hard-rule-warning-icon" title={props.customTitle ?? 'Hard rule violation'}>
                            <FontAwesomeIcon icon="exclamation-triangle" />
                        </RedTriangle>
                    )}
                    {props.violationType === StowageRuleConsequenceType.SoftRule && (
                        <YellowTriangle className="soft-rule-warning-icon" title={props.customTitle ?? 'Soft rule violation'}>
                            <FontAwesomeIcon icon="exclamation-triangle" />
                        </YellowTriangle>
                    )}
                    {props.includeText && <span className="violation-text">&nbsp;{getViolationType(props.violationType)}</span>}
                    {props.count && <>&nbsp;{props.count}</>}
                </WarningTriangle>
            )}
            {!props.violationType && <span></span>}
        </>
    );
};

export default ViolationListIconComponent;
